import { render } from "./ProductSelectCollectionOrder.html?vue&type=template&id=0f159399&scoped=true"
import script from "./ProductSelectCollectionOrder.js?vue&type=script&lang=js"
export * from "./ProductSelectCollectionOrder.js?vue&type=script&lang=js"

import "./ProductSelectCollectionOrder.css?vue&type=style&index=0&id=0f159399&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f159399"]])

export default __exports__